<template>
  <footer class="footer">
    <div class="footer-lead">
      <img src="/images/brand/lockup-white.svg" alt="SCOTT NOLES" />
      <p>{{ brand.tagline }}</p>
    </div>

    <div class="footer-columns">
      <div>
        <strong>{{ t('footer.brand') }}</strong>
        <router-link to="/about">{{ t('footer.about') }}</router-link>
        <router-link to="/insights">{{ t('footer.insights') }}</router-link>
        <router-link to="/dealers">{{ t('footer.dealers') }}</router-link>
        <router-link to="/contact">{{ t('footer.contact') }}</router-link>
      </div>
      <div>
        <strong>{{ t('footer.products') }}</strong>
        <router-link v-for="cat in categories" :key="cat.id" :to="'/products/' + cat.slug">{{ tf(cat, 'name') }}</router-link>
        <router-link to="/products">{{ t('footer.allProducts') }}</router-link>
      </div>
      <div>
        <strong>{{ t('footer.service') }}</strong>
        <router-link to="/warranty">{{ t('footer.warranty') }}</router-link>
        <router-link to="/warranty/query">{{ t('footer.warrantyQuery') }}</router-link>
        <router-link to="/warranty/authentication">{{ t('footer.auth') }}</router-link>
        <router-link to="/warranty/store">{{ t('footer.storeQuery') }}</router-link>
      </div>
      <div>
        <strong>{{ t('footer.contactCol') }}</strong>
        <span>{{ brand.telephone }}</span>
        <span>{{ brand.supportEmail }}</span>
        <span>{{ t('footer.hours') }}</span>
      </div>
    </div>

    <div class="footer-bottom">
      <span>© 2026 {{ brand.companyName }}</span>
      <div>
        <router-link to="/privacy">{{ t('footer.privacy') }}</router-link>
        <router-link to="/terms">{{ t('footer.terms') }}</router-link>
        <router-link to="/warranty">{{ t('footer.limitedWarranty') }}</router-link>
      </div>
    </div>
  </footer>
</template>

<script>
import { getOverview } from '../api/content'
import { langMixin } from '../utils/site-lang'
import { categories as fbCategories, brand } from '../data/site-data'

export default {
  name: 'GlobalFooter',
  mixins: [langMixin],
  data () {
    return { categories: fbCategories, brand }
  },
  created () {
    this.loadOverview()
  },
  methods: {
    async loadOverview () {
      try {
        const data = await getOverview()
        if (data && data.categories) this.categories = data.categories
      } catch (e) { /* 静态兜底 */ }
    }
  }
}
</script>
